<template>
  <!-- [sc-48893] Azioni di una riga degli elenchi. Da 720px in su i pulsanti
       restano in linea; sotto si raccolgono nel menu «⋯», con il `title` di
       ogni pulsante come etichetta. I pulsanti sono quelli della pagina,
       passati nello slot: nessuna logica duplicata. -->
  <div
    class="azioni-riga"
    :class="{ 'azioni-riga--aperto': aperto }"
    data-no-dettaglio
  >
    <button
      class="icons-button azioni-riga__toggle"
      type="button"
      title="Azioni"
      aria-label="Azioni"
      aria-haspopup="menu"
      :aria-expanded="aperto"
      @click.stop="toggle"
    >
      <i class="fa-solid fa-ellipsis"></i>
    </button>
    <div
      class="azioni-riga__voci"
      role="menu"
      :style="aperto ? posizione : null"
      @click="aperto = false"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "AzioniRiga",
  data() {
    return { aperto: false, posizione: {} };
  },
  watch: {
    aperto(v) {
      const metodo = v ? "addEventListener" : "removeEventListener";
      document[metodo]("click", this.chiudiFuori, true);
      window[metodo]("scroll", this.chiudi, true);
      window[metodo]("resize", this.chiudi);
    },
  },
  beforeUnmount() {
    this.aperto = false;
    document.removeEventListener("click", this.chiudiFuori, true);
    window.removeEventListener("scroll", this.chiudi, true);
    window.removeEventListener("resize", this.chiudi);
  },
  methods: {
    // Il menu e' `fixed`: dentro la tabella (overflow auto) verrebbe tagliato.
    // Si apre sotto il pulsante, o sopra se in fondo allo schermo non c'e' posto.
    toggle(e) {
      if (this.aperto) {
        this.aperto = false;
        return;
      }
      const r = e.currentTarget.getBoundingClientRect();
      const sotto = window.innerHeight - r.bottom > 260;
      this.posizione = {
        right: `${Math.max(8, window.innerWidth - r.right)}px`,
        ...(sotto
          ? { top: `${r.bottom + 4}px` }
          : { bottom: `${window.innerHeight - r.top + 4}px` }),
      };
      this.aperto = true;
    },
    chiudi() {
      this.aperto = false;
    },
    chiudiFuori(e) {
      if (!this.$el.contains(e.target)) this.aperto = false;
    },
  },
};
</script>

<style>
.azioni-riga {
  position: relative;
  display: inline-flex;
  justify-content: flex-end;
}

.azioni-riga__toggle {
  display: none !important;
}

.azioni-riga__voci {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
}

/* voci presenti solo nel menu mobile (es. PDF e DDT dei preventivi) */
.azioni-riga__voci .solo-menu {
  display: none !important;
}

@media (max-width: 719px) {
  .azioni-riga__toggle {
    display: inline-flex !important;
  }

  .azioni-riga__voci {
    display: none;
    position: fixed;
    z-index: 1000;
    flex-direction: column;
    align-items: stretch;
    gap: 2px;
    min-width: 220px;
    padding: 6px;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
  }

  .azioni-riga--aperto .azioni-riga__voci {
    display: flex;
  }

  .azioni-riga__voci .solo-menu {
    display: flex !important;
  }

  /* ogni pulsante diventa una voce: icona + il suo title come testo */
  .azioni-riga__voci > .icons-button,
  .azioni-riga__voci > .doc-btn {
    width: 100%;
    height: auto;
    justify-content: flex-start;
    gap: 10px;
    padding: 10px 12px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: inherit;
    font-size: 14px;
    text-align: left;
    white-space: nowrap;
  }

  .azioni-riga__voci > .icons-button:hover,
  .azioni-riga__voci > .doc-btn:hover {
    background: #f1f5f9;
  }

  .azioni-riga__voci > .icons-button::after,
  .azioni-riga__voci > .doc-btn::after {
    content: attr(title);
  }

  .azioni-riga__voci > .doc-btn > span {
    display: none;
  }
}
</style>
